<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Mémoire des apprenants" />
            <MemoireApprenant/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import MemoireApprenant from './MemoireApprenant.vue';


export default {
    name: 'PublicationPage',
    components: {
        NavBar,
        PageTitle,
        MemoireApprenant,
        FooterComp,
    }
}
</script>